import { useMemo } from 'react';
import { getCurrentEnterpriseChainId } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { getEnterprises } from '@mews-commander/legacy-entities/src/ducks/enterprises';
import { useCommanderSelector } from '@mews-commander/utils';

export const usePropertiesInEnterpriseChainId = () => {
    const enterpriseChainId = useCommanderSelector<string>(getCurrentEnterpriseChainId);
    const enterprises = useCommanderSelector(getEnterprises);

    return useMemo(() => {
        const enterpriseList = Object.values(enterprises);
        if (enterpriseList.length > 0) {
            const filteredProperties = enterpriseList.filter((value) => value.chainId === enterpriseChainId);
            const propertiesId: string[] = filteredProperties.map((property) => property.id);

            return {
                properties: filteredProperties,
                propertiesId,
            };
        }

        return {
            properties: [],
            propertiesId: [],
        };
    }, [enterpriseChainId, enterprises]);
};
